import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { useLang } from "../../lib/i18n";
import { canInstall, isIos, isStandalone, onPwaChange, promptInstall } from "../../lib/pwa";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export const InstallAppButton = ({ overHero, compact, testid = "nav-install-app" }) => {
  const { t } = useLang();
  const [, tick] = useState(0);
  const [help, setHelp] = useState(false);
  useEffect(() => onPwaChange(() => tick((x) => x + 1)), []);
  if (isStandalone()) return null;
  const click = async () => {
    if (canInstall()) {
      if (await promptInstall()) toast.success(t("app_installed"));
    } else setHelp(true);
  };
  return (
    <>
      <button onClick={click} title={t("install_app")} aria-label={t("install_app")} data-testid={testid}
        className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${overHero ? "border-white/40 bg-black/20 text-white backdrop-blur-sm hover:bg-white/10" : "border-slate-300 text-[#0A2540] hover:border-[#00A8B5]"}`}>
        <Download size={14} />{!compact && <span className="hidden xl:inline">{t("install_app")}</span>}
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent data-testid="install-app-help">
          <DialogHeader><DialogTitle className="font-display">{t("install_app")}</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">{t("install_text")}</p>
          <p className="rounded-xl bg-slate-50 p-4 text-sm font-semibold text-[#0A2540]" data-testid="install-app-instructions">{isIos() ? t("install_ios") : t("install_browser")}</p>
        </DialogContent>
      </Dialog>
    </>
  );
};
